import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "edit-icon",
  "use": "edit-icon-usage",
  "viewBox": "0 0 22 23",
  "content": "<symbol viewBox=\"0 0 22 23\" id=\"edit-icon\">\n  <path xmlns=\"http://www.w3.org/2000/svg\" d=\"M14.014,7.971l2.015,2.015l-7.554,7.553l-2.014,0l0,-2.014l7.553,-7.553l0,-0.001Zm1.511,-1.51l2.014,2.014l-1.007,1.007l-2.014,-2.014l1.007,-1.007Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol